import i18next from 'i18next'

import { initReactI18next, useTranslation } from 'react-i18next'
const resources = {
  en: {
    translation: {
      toggle_next_language_label: 'CZ',
      toggle_next_language: 'cs',
      date_locale: 'en-GB',
      notifications: 'Notifications',
      events: 'Events',
      map: 'Map',
      parking: 'Parking',
      voting: 'Voting',
      achievements: 'Achievements',
      disconnected: 'Connection error',
      header: '/header.svg',
      logout: 'Logout',
      add: 'Add',
      newNotification: 'New notification',
      newEvent: 'New event',
      loginRedirect: 'You are being redirected for authentication. ',
      limitedAccess: 'Login',
      newCampaign: 'New campaign',
      day_0: 'Sunday',
      day_1: 'Monday',
      day_2: 'Tuesday',
      day_3: 'Wednesday',
      day_4: 'Thursday',
      day_5: 'Friday',
      day_6: 'Saturday',
      today: 'Today',
      hamburgerMenuBehaviour: 'Hamburger menu behavior:',
      userRelatedInformation: 'User related information:',
      languageSelectors: 'Language selectors:',
      dataCards: 'Cards:',
      votingSelection: 'Voting selectors:',
      more: 'More',
      vote: 'Vote',
      voteLabel: 'Vote',
      changeVote: 'Change vote',
      containers: 'Containers:',
      selectFursuiter: 'Select Fursuiter:',
      'routing-widgets': 'widgets',
      'routing-all': 'all',
      'routing-main': 'main',
      'routing-containers': 'containers',
      'routing-cards': 'cards',
      'routing-voting': 'voting',
      'routing-map': 'map',
      Continue: 'Continue',
      Open: 'Open',
      'server-error': 'There was an error while connecting to servers.',
      'server-error-help':
        'There was an error while connecting to servers, using cached data. Please check your internet connection and refresh the page.',
      'consite-unavailable': 'Error connecting to consite server',
      'consite-unavailable-help':
        'There was an error while connecting to local server. Using public server which contains outdated data. Please check that you are connected to the Česfur network - "cesfur" - and refresh the page',
      'no-data-available': 'No data available',
      'user-menu': 'In this menu, you will see user related items.',
      'companion-authorization':
        'Please continue to convention page for login, then approve companion client access.',
      'authorization-error':
        'There was an error during authorization & authentication.',
      'not-registered': 'You are not registered to convention.',
      'logout-success': 'Logout success.',
      login: 'Login',
      retry: 'Retry',
      save: 'Save',
      cancel: 'Cancel',
      'no-votes-remaining': 'No votes remaining',
      'votes-remaining': 'Votes remaining',
      'voting-help':
        'You can vote in two categories, with 3 votes available in each category. Feel free to distribute your votes as you wish. You can change your vote at any time, but please remember to do so before the deadline',
      'authentication-expired':
        'Your authentication expired, please login again.',
      'no-access': "You don't have access to this page, please login.",
      'on-bar': 'On Tap This Year',
      'created-by':
        'Application created by @Maiyun (2026) for ČESFUR z.s. ČESFUR z.s. is rightful owner of the content. Created using React Js and MUI',
      about: 'About',
      'About application': 'About application',
      'Reveal version info': 'Reveal version info',
      'Hide version info': 'Hide version info',
      'Loaded client version:': 'Loaded client version:',
      'Loaded model version:': 'Loaded model version:',
      'Loaded server version:': 'Loaded server version:',
      coninfo: 'ConInfo',
      'Application is loading': 'Application is loading',
      loading: 'Loading',
      'Show votes only:': ' Show votes only:',
      'Reset application cache': 'Reset application cache',
      'Are you sure you want to reset application and reload data?':
        'Are you sure you want to reset application and reload data?',
      Yes: 'Yes',
      No: 'No',
      'You can still vote until:': 'You can still vote until:',
      'Voting has ended': 'Voting has ended',
      'report-bug': 'Report bug',
      'share-me': 'Share me:',
      'add favorite': 'Add favorite',
      'remove favorite': 'Remove favorite',
      'nothing here - events': 'Nothing is here, you need to add favorite events first',
      'nothing here - assigned': 'Nothing is here, you are not assigned to any event',
      'my-achievements': 'My Achievements',
      yaps: 'Yaps',
      send: 'Send',
      'new-yap': 'New Yap',
      'empty-yap-validation-error': 'Yap cannot be empty',
      'internal-server-error': 'Oops, something went wrong',
      'authorization-expired': 'Authorization with conreg server expired, please try to log in again',
      'conops-note': 'Note for Conops:',
      'conops-assigned': 'Assigned Conops:',
      'security-note': 'Note for Security:',
      'security-assigned': 'Assigned Security:',
      presenters: 'Presenters:',
      equipment: 'Note (Technical equipment):',
      'date-notifications': 'Deadlines',
      'check-notifications': 'Discover',
      'dont-miss-out-notifications': 'Don\'t miss out',
      'coninfo-notifications': 'Announcements',
      'convention-announcement': 'Announcement',
      'nothing here - achievements': 'You still haven\'t earned any achievements for this year. It can take several minutes before a new achievement shows here',
      'all-achievements': 'Available this year',
      'user-achievements': 'Earned',
      'achievement-awarded': 'Received',
      'achievement-additional-instructions': 'How to achieve?',
      'virtual-badge-title': 'Virtual badge',
      'virtual-badge-show': 'Show badge',
      'virtual-badge-nickname': 'Nickname',
      'virtual-badge-number': 'Badge number',
      'deadline-confirm': 'Complete',
      'deadline-confirmed': 'Completed',
      'deadline-ended': 'Ended',
      'ticker-in': 'in',
      'ticker-expand': 'Expand news ticker',
      'no-announcements': 'No announcements at the moment',
      'today-tab': 'Today',
      'snacks-title': 'Snacks & Beers Exchange',
      'snacks-vote-for': 'Vote for:',
      'snacks-own-table-no-vote': 'You cannot vote for your own table',
      'snacks-votes-remaining': 'Remaining votes',
      'snacks-table': 'Table',
      'snacks-register-my-table': 'Register my table',
      'snacks-register-title': 'Register your table',
      'snacks-admin-create-title': 'Add registration',
      'snacks-admin-edit-title': 'Edit registration',
      'snacks-admin-add-registration': 'Add registration',
      'snacks-register-table': 'Register table',
      'snacks-edit-my-table': 'Edit my table',
      'snacks-table-name-label': 'Table name',
      'snacks-pending-approval': 'Your registration is pending admin approval',
      'snacks-your-table': 'Your table',
      'snacks-go-vote': 'Go vote',
      'snacks-back-to-all': '← Back to all tables',
      'snacks-table-not-found': 'Table {{number}} not found',
      'snacks-table-error': 'Failed to load table information',
      'snacks-table-not-active': 'This table is not currently available for voting',
      'snacks-voting-not-open': 'Voting is not open yet',
      'snacks-voting-not-started': 'Snacks and beer exchange voting still did not start',
      'snacks-no-registrations': 'No tables registered yet',
      'snacks-no-voted-tables': 'You have not voted for any table yet',
      'snacks-no-own-registration': 'You have not registered a table yet',
      'snacks-field-name': 'Table name',
      'snacks-field-description': 'Description',
      'snacks-field-owner-nick': 'Badge',
      'snacks-field-table-number': 'Table number',
      'snacks-field-status': 'Status',
      'snacks-name-invalid': 'Name may only contain letters, digits, spaces, apostrophes, hyphens and dots (max 100 characters)',
      'snacks-name-required-hint': 'Required',
      'snacks-name-optional-hint': 'Optional — defaults to your badge nick',
      'snacks-description-too-long': 'Description must be 500 characters or fewer',
      'snacks-owner-nick-required': 'Owner nickname is required',
      'snacks-already-registered': 'A table is already registered for this user.',
      'snacks-status-pending': 'Pending',
      'snacks-status-active': 'Active',
      'snacks-status-disabled': 'Disabled',
      'snacks-locked-tooltip': 'Cannot change status — this table has votes and cannot be reactivated',
      'snacks-edit': 'Edit',
      'snacks-deactivate': 'Deactivate',
      'snacks-deactivate-confirm-title': 'Deactivate registration',
      'snacks-deactivate-confirm': 'Are you sure you want to deactivate this registration?',
      'snacks-show-qr': 'Show table QR code',
      'snacks-hide-qr': 'Hide QR',
      'snacks-qr-alt': 'QR code',
      'snacks-qr-my-table': 'Your table QR code',
      'snacks-qr-for-table': 'QR code for Table {{number}}',
      'snacks-qr-error': 'QR code unavailable',
      'snacks-qr-scan-button': 'Scan Table QR',
      'snacks-qr-scan-title': 'Scan Table QR Code',
      'snacks-qr-scan-close': 'Close scanner',
      'snacks-qr-scan-hint': 'Point the camera at a table QR code',
      'snacks-qr-scan-invalid': 'Invalid table QR code',
      'snacks-qr-scan-denied-title': 'Camera access denied',
      'snacks-qr-scan-denied-help': 'Allow browser access your camera or use phone built-in camera',
      'snacks-tab-all-tables': 'All Tables',
      'snacks-tab-my-table': 'My Table',
      'snacks-tab-results': 'Results',
      'snacks-results-title': 'Voting Results',
      'snacks-results-filter-all': 'All',
      'snacks-results-no-data': 'No results yet',
      'snacks-results-total': 'Total',
      'snacks-results-votes': '{{count}} vote',
      'snacks-results-votes_other': '{{count}} votes',
      'snacks-field-nick': 'Nick',
      'snacks-field-badge-number': 'Badge number',
      'snacks-nick-required': 'Nick is required',
      'snacks-nick-invalid': 'Nick must be 1–100 characters (letters, digits, spaces, hyphens, apostrophes, dots)',
      'snacks-badge-required': 'Badge number is required',
      'snacks-badge-number-hint': 'Attendee badge number',
      'snacks-table-number-required': 'Table number is required',
      'snacks-table-number-invalid': 'Must be a positive whole number',
      'snacks-table-number-conflict': 'This table number is already taken',
      'snacks-status-deactivated': 'Deactivated',
      'snacks-status-waiting': 'Waiting for Approval',
      'snacks-field-country': 'Country',
      'snacks-country-none': 'Not specified',
      'snacks-filter-label': 'Filter',
      'snacks-filter-all': 'All',
      'snacks-filter-my-votes': 'My Votes',
      'snacks-activate': 'Activate',
      'snacks-approve': 'Approve',
      'snacks-approve-title': 'Approve registration',
      'snacks-approve-hint': 'Assign a table number to approve this registration.',
      'snacks-error-generic': 'An error occurred. Please try again.',
      'snacks-error-already-active': 'This user already has an active table.',
      'snacks-error-title': 'Error',
      'notification-login-required': 'Login required',
      'fursuit-voting-title': 'Fursuit Voting',
      'fursuit-votes-remaining': 'Remaining votes',
      'fursuit-voting-not-started': 'Fursuit voting has not started yet',
      'fursuit-voting-ended': 'Fursuit voting has ended',
      tearoom: 'Tea Room',
      'tearoom-no-menu': 'No menu available',
      'tearoom-loading': 'Loading menu',
      'achievement-show-instructions': 'Show instructions',
      'achievement-label-description': 'Description:',
      'achievement-label-instructions': 'Instructions:'
    }
  },
  cs: {
    translation: {
      toggle_next_language_label: 'EN',
      toggle_next_language: 'en',
      date_locale: 'cs-CZ',
      notifications: 'Oznámení',
      events: 'Program',
      map: 'Mapa',
      parking: 'Parkování',
      voting: 'Hlasování',
      achievements: 'Trofeje',
      disconnected: 'Chyba připojení',
      header: '/header.svg',
      logout: 'Odhlásit',
      add: 'Přidat',
      newNotification: 'Nové oznámení',
      newEvent: 'Nová událost',
      loginRedirect: 'Právě probíhá přesměrování pro přihlášení',
      limitedAccess: 'Přihlášení',
      newCampaign: 'Nová Kampaň',
      day_0: 'Neděle',
      day_1: 'Pondělí',
      day_2: 'Úterý',
      day_3: 'Středa',
      day_4: 'Čtvrtek',
      day_5: 'Pátek',
      day_6: 'Sobota',
      today: 'Dnes',
      widgets: 'Komponenty',
      allWidgets: 'Všechny',
      hamburgerMenuBehaviour: 'Chování hlavní nabídky:',
      userRelatedInformation: 'Zobrazení informací o uživateli:',
      languageSelectors: 'Výběr jazyka:',
      dataCards: 'Karty:',
      votingSelection: 'Volby pro hlasování',
      more: 'Více',
      vote: 'Volba',
      voteLabel: 'Hlasuj',
      changeVote: 'Změň hlas',
      containers: 'Kontejnery:',
      selectFursuiter: 'Zvol Fursuitera:',
      Continue: 'Pokračovat',
      Open: 'Otevřít',
      'routing-widgets': 'komponenty',
      'routing-all': 'všechny',
      'routing-main': 'main',
      'routing-containers': 'kontejnery',
      'routing-cards': 'karty',
      'routing-voting': 'hlasování',
      'routing-map': 'mapa',
      'server-error': 'Nastala chyba během připojování k serverům.',
      'server-error-help':
        'Chyba během připojování k serverům, prosím zkontrolujte zda jste připojeni k internetu a zaktualizujte prosím stránky.',
      'consite-unavailable':
        'Nastala chyba během připojování k lokálnímu serveru',
      'consite-unavailable-help':
        'Nastala chyba během připojování k lokálnímu serveru, prosím zkontrolujte zda jste připojeni k Česfur wi-fi - "cesfur" a zaktualizujte prosím stránky.',
      'no-data-available': 'Žádné data k dispozici',
      'user-menu': 'V tomto menu naleznete uživatelské funkce.',
      'companion-authorization':
        'Prosím pokračujte na hlavní web pro přihlášení a autorizaci aplikace.',
      'authorization-error': 'Nastala chyba během přihlášení.',
      'not-registered': 'Nejste přihlášený na žádný con.',
      'logout-success': 'Byli jste odhlášeni',
      retry: 'Zkusit znovu',
      login: 'Přihlásit',
      save: 'Uložit',
      cancel: 'Zrušit',
      'no-votes-remaining': 'Nezbývají žádné hlasy',
      'votes-remaining': 'Zbývající hlasy',
      'voting-help':
        'Máte omezené množství hlasů které můžete rozdat, pokud už jste nějaké hlasy rozdali, kdykoliv je můžete přerozdělit znovu.',
      'authentication-expired':
        'Autorizace vypršela, prosím přihlaste se znova.',
      'no-access': 'Nemáte přístup do této sekce, prosím přihlašte se.',
      'on-bar': 'Letos na pípě',
      'created-by':
        'Aplikace vytvořena @Maiyun (2026) pro ČESFUR z.s. Obsah ve vlastnictví ČESFUR z.s. Vytvořeno za použití React JS a MUI',
      about: 'O aplikaci',
      'About application': 'O aplikaci',
      'Reveal version info': 'Zobrazit informace o verzi',
      'Hide version info': 'Skrýt informace o verzi',
      'Loaded client version:': 'Načtená verze klienta:',
      'Loaded model version:': 'Načtená modelová verze:',
      'Loaded server version:': 'Načtená verze serveru:',
      coninfo: 'ConInfo',
      'Application is loading': 'Aplikace se načítá',
      loading: 'Načítání',
      'Show votes only:': 'Zobrazit jen s hlasy:',
      'Reset application cache': 'Reset lokální cache',
      'Are you sure you want to reset application and reload data?':
        'Jste si jisti že chcete vyresetovat aplikaci a obnovit data?',
      Yes: 'Ano',
      No: 'Ne',
      'You can still vote until:': 'Stále můžete hlasovat do:',
      'Voting has ended': 'Hlasování skončilo',
      'report-bug': 'Nahlásit bug',
      'share-me': 'Sdílej mě:',
      'add favorite': 'Přidej k oblíbeným',
      'remove favorite': 'Odstraň z oblíbených',
      'nothing here - events': 'Nic zde není, nejdříve musíte vybrat Vaše oblíbené programové body',
      'nothing here - assigned': 'Nic zde není, nejste přiřazen k žádnému programovému bodu',
      'my-achievements': 'Mé trofeje',
      yaps: 'Štěky',
      send: 'Odeslat',
      'new-yap': 'Nový štěk',
      'empty-yap-validation-error': 'Nelze odeslat prázdnou zprávu',
      'internal-server-error': 'Jejda, něco se pokazilo',
      'authorization-expired': 'Autorizace s conreg serverem vypršela, přihlašte se prosím znovu',
      'conops-note': 'Poznámka (Conops):',
      'conops-assigned': 'Přiřazení Conops:',
      'security-note': 'Poznámka (Security):',
      'security-assigned': 'Přiřazení Security:',
      presenters: 'Prezentující:',
      equipment: 'Poznámka (Technické vybavení):',
      'date-notifications': 'Uzávěrky',
      'check-notifications': 'Zajímavosti',
      'dont-miss-out-notifications': 'Nenechte si ujít',
      'coninfo-notifications': 'Oznámení',
      'convention-announcement': 'Oznámení',
      'all-achievements': 'Letošní trofeje',
      'user-achievements': 'Získané trofeje',
      'nothing here - achievements': 'Pro tento rok jste stále nezískali žádnou trofej. Může trvat i několik minut, než se nová trofej zobrazí',
      'no-announcements': 'Žádné oznámení',
      'achievement-awarded': 'Získáno',
      'achievement-additional-instructions': 'Jak získat?',
      'virtual-badge-title': 'Virtuální badge',
      'virtual-badge-show': 'Zobrazit badge',
      'virtual-badge-nickname': 'Přezdívka',
      'virtual-badge-number': 'Číslo badge',
      'deadline-confirm': 'Dokončit',
      'deadline-confirmed': 'Potvrzeno',
      'deadline-ended': 'Ukončeno',
      'ticker-in': 'za',
      'ticker-expand': 'Rozbalit novinky',
      'today-tab': 'Dnes',
      'snacks-title': 'Výměna snacků a piva',
      'snacks-vote-for': 'Hlasovat pro:',
      'snacks-own-table-no-vote': 'Nemůžete hlasovat pro svůj vlastní stůl',
      'snacks-votes-remaining': 'Zbývající hlasy',
      'snacks-table': 'Stůl',
      'snacks-register-my-table': 'Zaregistrovat můj stůl',
      'snacks-register-title': 'Zaregistrovat váš stůl',
      'snacks-admin-create-title': 'Přidat registraci',
      'snacks-admin-edit-title': 'Upravit registraci',
      'snacks-admin-add-registration': 'Přidat registraci',
      'snacks-register-table': 'Zaregistrovat stůl',
      'snacks-edit-my-table': 'Upravit můj stůl',
      'snacks-table-name-label': 'Název stolu',
      'snacks-pending-approval': 'Vaše registrace čeká na schválení administrátorem',
      'snacks-your-table': 'Váš stůl',
      'snacks-go-vote': 'Hlasovat',
      'snacks-back-to-all': '← Zpět na všechny stoly',
      'snacks-table-not-found': 'Stůl {{number}} nebyl nalezen',
      'snacks-table-error': 'Nepodařilo se načíst informace o stolu',
      'snacks-table-not-active': 'Tento stůl momentálně není dostupný pro hlasování',
      'snacks-voting-not-open': 'Hlasování ještě není otevřeno',
      'snacks-no-registrations': 'Zatím žádné registrované stoly',
      'snacks-no-voted-tables': 'Zatím jste nehlasovali pro žádný stůl',
      'snacks-no-own-registration': 'Zatím jste nezaregistrovali stůl',
      'snacks-field-name': 'Název stolu',
      'snacks-field-description': 'Popis',
      'snacks-field-owner-nick': 'Odznak',
      'snacks-field-table-number': 'Číslo stolu',
      'snacks-field-status': 'Stav',
      'snacks-name-invalid': 'Název smí obsahovat pouze písmena, číslice, mezery, apostrofy, pomlčky a tečky (max 100 znaků)',
      'snacks-name-required-hint': 'Povinné',
      'snacks-name-optional-hint': 'Nepovinné — výchozí je vaše badge přezdívka',
      'snacks-description-too-long': 'Popis musí mít nejvýše 500 znaků',
      'snacks-owner-nick-required': 'Přezdívka majitele je povinná',
      'snacks-already-registered': 'Pro tohoto uživatele je již stůl zaregistrován.',
      'snacks-status-pending': 'Čeká',
      'snacks-status-active': 'Aktivní',
      'snacks-status-disabled': 'Deaktivováno',
      'snacks-locked-tooltip': 'Stav nelze změnit — tento stůl má hlasy a nelze jej znovu aktivovat',
      'snacks-edit': 'Upravit',
      'snacks-deactivate': 'Deaktivovat',
      'snacks-deactivate-confirm-title': 'Deaktivovat registraci',
      'snacks-deactivate-confirm': 'Opravdu chcete tuto registraci deaktivovat?',
      'snacks-show-qr': 'Zobrazit QR kód stolu',
      'snacks-hide-qr': 'Skrýt QR',
      'snacks-qr-alt': 'QR kód',
      'snacks-qr-my-table': 'QR kód vašeho stolu',
      'snacks-qr-for-table': 'QR kód pro Stůl {{number}}',
      'snacks-qr-error': 'QR kód není dostupný',
      'snacks-qr-scan-button': 'Skenovat QR stolu',
      'snacks-qr-scan-title': 'Naskenovat QR kód stolu',
      'snacks-qr-scan-close': 'Zavřít skener',
      'snacks-qr-scan-hint': 'Namiřte kameru na QR kód stolu',
      'snacks-qr-scan-invalid': 'Neplatný QR kód stolu',
      'snacks-qr-scan-denied-title': 'Přístup ke kameře byl zamítnut',
      'snacks-qr-scan-denied-help': 'Povolte prohlížeči přístup ke kameře nebo použijte vestavěnou kameru telefonu',
      'snacks-tab-all-tables': 'Všechny stoly',
      'snacks-tab-my-table': 'Můj stůl',
      'snacks-tab-results': 'Výsledky',
      'snacks-results-title': 'Výsledky hlasování',
      'snacks-results-filter-all': 'Vše',
      'snacks-results-no-data': 'Zatím žádné výsledky',
      'snacks-results-total': 'Celkem',
      'snacks-results-votes': '{{count}} hlas',
      'snacks-results-votes_other': '{{count}} hlasů',
      'snacks-field-nick': 'Přezdívka',
      'snacks-field-badge-number': 'Číslo badge',
      'snacks-nick-required': 'Přezdívka je povinná',
      'snacks-nick-invalid': 'Přezdívka musí mít 1–100 znaků (písmena, číslice, mezery, pomlčky, apostrofy, tečky)',
      'snacks-badge-required': 'Číslo badge je povinné',
      'snacks-badge-number-hint': 'Číslo badge účastníka',
      'snacks-table-number-required': 'Číslo stolu je povinné',
      'snacks-table-number-invalid': 'Musí být kladné celé číslo',
      'snacks-table-number-conflict': 'Toto číslo stolu je již obsazeno',
      'snacks-status-deactivated': 'Deaktivováno',
      'snacks-status-waiting': 'Čeká na schválení',
      'snacks-field-country': 'Země',
      'snacks-country-none': 'Neuvedeno',
      'snacks-filter-label': 'Filtr',
      'snacks-filter-all': 'Vše',
      'snacks-filter-my-votes': 'Moje hlasy',
      'snacks-activate': 'Aktivovat',
      'snacks-approve': 'Schválit',
      'snacks-approve-title': 'Schválit registraci',
      'snacks-approve-hint': 'Přiřaďte číslo stolu pro schválení registrace.',
      'snacks-error-generic': 'Nastala chyba. Zkuste to prosím znovu.',
      'snacks-error-already-active': 'Tento uživatel již má aktivní stůl.',
      'snacks-error-title': 'Chyba',
      'notification-login-required': 'Vyžaduje přihlášení',
      'fursuit-voting-title': 'Hlasování o fursuity',
      'fursuit-votes-remaining': 'Zbývající hlasy',
      'fursuit-voting-not-started': 'Hlasování o fursuity ještě nezačalo',
      'fursuit-voting-ended': 'Hlasování o fursuity skončilo',
      tearoom: 'Kavárna',
      'tearoom-no-menu': 'Žádné menu není dostupné',
      'tearoom-loading': 'Načítání menu',
      'achievement-show-instructions': 'Zobrazit instrukce',
      'achievement-label-description': 'Popis:',
      'achievement-label-instructions': 'Instrukce:'
    }
  }
}

i18next.use(initReactI18next).init({
  debug: false,
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false
  }
})

/* eslint-disable react/display-name */
/* TODO: Anonymous function naming */
export const withTranslation = (Component) => (props) => {
  const engine = useTranslation()
  return (
    <Component {...props} i18nEngine={engine} language={engine.i18n.language} />
  )
}

export const translateText = function (items, i18n) {
  try {
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.lang === i18n.language) {
        return item.text
      }
    }
  } catch (Error) {
    console.error('There was error')
    console.error(Error)
    return ''
  }

  return ''
}

export default i18next
